import React from 'react';
import { formatCurrency, formatPercentage } from '../utils/taxCalculations';
import './TaxSummary.css';

function TaxSummary({ calculation, simulationResult, hasSimulationsActive }) {
  const summaryCards = [
    {
      id: 'gross',
      title: 'Gross Salary',
      value: formatCurrency(calculation.grossSalary),
      icon: '💵',
      type: 'primary',
    },
    {
      id: 'tax',
      title: 'Income Tax',
      value: formatCurrency(calculation.incomeTax.totalTax),
      subtitle: `Effective rate: ${formatPercentage(calculation.incomeTax.effectiveRate)}`,
      icon: '📋',
      type: 'deduction',
    },
    {
      id: 'ni',
      title: 'National Insurance',
      value: formatCurrency(calculation.nationalInsurance.totalNI),
      icon: '🏥',
      type: 'deduction',
    },
    {
      id: 'total-deductions',
      title: 'Total Deductions',
      value: formatCurrency(calculation.totalDeductions),
      icon: '➖',
      type: 'deduction',
    },
    {
      id: 'take-home',
      title: 'Take Home Pay',
      value: formatCurrency(calculation.takeHome),
      subtitle: `${formatCurrency(calculation.monthlyTakeHome)}/month`,
      icon: '💰',
      type: 'highlight',
    },
  ];

  return (
    <div className="tax-summary">
      <h2>Your Tax Summary</h2>
      
      <div className="summary-cards">
        {summaryCards.map((card) => (
          <div key={card.id} className={`summary-card ${card.type}`}>
            <div className="card-icon">{card.icon}</div>
            <div className="card-content">
              <span className="card-title">{card.title}</span>
              <span className="card-value">{card.value}</span>
              {card.subtitle && (
                <span className="card-subtitle">{card.subtitle}</span>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Simulation Comparison */}
      {hasSimulationsActive && (
        <div className="simulation-comparison">
          <h3>With Policy Changes</h3>
          <div className="comparison-grid">
            <div className="comparison-item current">
              <span className="comparison-label">Current Take Home</span>
              <span className="comparison-value">{formatCurrency(calculation.takeHome)}</span>
              <span className="comparison-monthly">{formatCurrency(calculation.monthlyTakeHome)}/month</span>
            </div>
            <div className="comparison-arrow">→</div>
            <div className="comparison-item simulated">
              <span className="comparison-label">Simulated Take Home</span>
              <span className="comparison-value">{formatCurrency(simulationResult.simulated.takeHome)}</span>
              <span className="comparison-monthly">{formatCurrency(simulationResult.simulated.monthlyTakeHome)}/month</span>
            </div>
            <div className="comparison-savings">
              <span className="savings-badge">
                +{formatCurrency(simulationResult.savings.annual)}/year
              </span>
            </div>
          </div>
          
          <div className="rate-comparison">
            <div className="rate-item">
              <span className="rate-label">Current Basic Rate</span>
              <span className="rate-value">20%</span>
            </div>
            <div className="rate-arrow">→</div>
            <div className="rate-item reduced">
              <span className="rate-label">Simulated Basic Rate</span>
              <span className="rate-value">{simulationResult.simulated.basicRate}%</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TaxSummary;
